<template>
<div class="element-control" :xxxxclass="{'full-height': !(parent)}" :id="element.title" v-if="element">
    <component :is="componentName" v-if="componentName && element.type != 'Group'" :parent="parent" :element="element" @change="valueChanged" />
    <SectionLayout v-if="element.type=='Group'" :section="element" :parent="parent">
        <SortableList :items="element.elements">
            <template v-slot:default="{item}">
                <ElementControl :element="item" :parent="element" />
            </template>
            <template v-slot:menu={item} >
                <v-list-item @click="$set(item, 'value', null)">
                    <v-list-item-title>Clear Value</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!item.na" @click="$set(item, 'na', true)">
                    <v-list-item-title>Not Applicable</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.na" @click="$set(item, 'na', null) ">
                    <v-list-item-title>Mark Applicable</v-list-item-title>
                </v-list-item>
            </template>               
        </SortableList>
    </SectionLayout>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import ElementLayout from '../screens/ElementLayout'
import GroupControl from './controls/GroupControl'
import SectionLayout from '@/screens/SectionLayout'
import draggable from 'vuedraggable'
import SortableList from '../ui-elements/SortableList'

import TextControl from './controls/TextControl'
import NumberControl from './controls/NumberControl'
import SwitchControl from './controls/SwitchControl'
import CheckboxControl from './controls/CheckboxControl'
import DateControl from './controls/DateControl'
import SelectUserControl from './controls/SelectUserControl'
import CurrencyControl from './controls/CurrencyControl'
import DateRangeControl from './controls/DateRangeControl'
import ButtonControl from './controls/ButtonControl'
import OptionsControl from './controls/OptionsControl'
import DropdownControl from './controls/DropdownControl'
import HtmlControl from './controls/HtmlControl'
import ImageControl from './controls/ImageControl'
import UploadControl from './controls/UploadControl'

export default {
    data() {
        return {
            previousValue: null
        }
    },

    components: {
        ElementLayout,
        TextControl,
        HtmlControl,
        NumberControl,
        DateControl,
        SwitchControl,
        CheckboxControl,
        UploadControl,
        SelectUserControl,
        CurrencyControl,
        DateRangeControl,
        GroupControl,
        SectionLayout,
        ButtonControl,
        OptionsControl,
        DropdownControl,
        draggable,
        SortableList,
        ImageControl,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        componentName() {
            if(!this.element)
                return null
            const controlName = this.element.control || this.element.type
            if(!controlName)
                debugger
            return controlName.replace(' ', '')  + 'Control'
        },
        childElements() {
            return this.element.elements.map(o => {
                let el = {...o}
                el.record = el.record || this.element.record
                return el
            })
        }
    },

    methods: {

        valueChanged(changeObj) {
            const changes = {value: this.element.value, previousValue: this.previousValue}
            console.log('** Value Changed **', changes)
            this.storePreviousValue()
        },

        storePreviousValue() {
            this.previousValue = this.element.value
        }

    },

    created() {
        this.storePreviousValue()
    },  

    mounted() {

    },

    watch: {
        'element.value': {
            handler: function(newVal, oldVal) {
                console.log('Changed from ' + oldVal + ' to ' + newVal)
            }
        }
    }
}
</script>

<style scoped>
    .full-height{
        height: calc(100% - 1px);
        border: dashed 2px red;
        overflow-y:auto;
    }

</style>




// WEBPACK FOOTER //
// ElementControl.vue?de552ea2